import { connect } from 'react-redux'
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import styled from 'styled-components'

import { Modal } from '../../common-components'

const Warning = styled.p`
  color: red;
`

export const _CampaignExpiredPopup = ({ notificationMessage, onExit, backToHome, ...props }) => (
  <Modal
    isOpen={notificationMessage !== 'None'}
    backdrop={true}
    size="lg"
    modalClassName="default-bootstrap remote-selling-modal"
    toggle={() => {
      onExit()
    }}
  >
    <ModalHeader
      toggle={() => {
        onExit()
      }}
    >
      กรุณาตรวจสอบข้อมูล
    </ModalHeader>
    <ModalBody>
      <p>{notificationMessage.message}</p>
      {Array.isArray(notificationMessage.warningmessage) ? (
        notificationMessage.warningmessage.map((message) => <Warning>{message}</Warning>)
      ) : (
        <Warning>{notificationMessage.warningmessage}</Warning>
      )}
    </ModalBody>
    <ModalFooter>
      <div className="bottom">
        <Button
          color="outline-primary"
          onClick={() => {
            onExit()
          }}
        >
          ปิด
        </Button>
      </div>
    </ModalFooter>
  </Modal>
)

export default connect(null, null)(_CampaignExpiredPopup)
